import React from "react";

export const LoadingSpinner = ({
	size = "md",
	message = "",
	className = "",
	// layout
	center = false,
	overlay = false,
	fullScreen = false,
	// backdrop
	backdrop = false,
	backdropColor = "rgba(0, 0, 0, 0.05)",
	// appearance
	color,
	trackColor,
	thickness,
	speed,
	// accessibility
	label = "Loading",
}) => {
	const sizeMap = {
		sm: "1.5rem",
		md: "3rem",
		lg: "5rem",
	};

	const dim = sizeMap[size] || sizeMap.md;

	const strokeWidth = thickness ?? 4;

	const svgStyle = {
		width: dim,
		height: dim,
		...(speed ? { animationDuration: speed } : {}),
	};

	const arcStyle = {
		...(color ? { stroke: color } : {}),
	};

	const trackStyle = {
		...(trackColor ? { stroke: trackColor } : {}),
	};

	const wrapperClasses = [
		"loading-spinner",
		center && "loading-spinner--center",
		overlay && "loading-spinner--overlay",
		fullScreen && "loading-spinner--full-screen",
		backdrop && "loading-spinner--backdrop",
		className,
	]
		.filter(Boolean)
		.join(" ");

	const wrapperStyle =
		backdrop
			? { backgroundColor: backdropColor }
			: undefined;

	return (
		<div className={wrapperClasses} style={wrapperStyle}>
			<div className="loading-spinner__inner">
				<svg
					className="loading-spinner__svg"
					style={svgStyle}
					viewBox="0 0 50 50"
					xmlns="http://www.w3.org/2000/svg"
					role="status"
					aria-label={label}>
					<circle
						className="loading-spinner__track"
						cx="25"
						cy="25"
						r="20"
						fill="none"
						strokeWidth={strokeWidth}
						style={trackStyle}
					/>
					<circle
						className="loading-spinner__arc"
						cx="25"
						cy="25"
						r="20"
						fill="none"
						strokeWidth={strokeWidth}
						strokeLinecap="round"
						style={arcStyle}
					/>
				</svg>
				{message && <span className="loading-spinner__message">{message}</span>}
			</div>
		</div>
	);
};

const SPINNER_COLORS = {
	white: "#fff",
	red: "#ac2431",
	blue: "#337ab7",
};

export const ButtonSpinner = ({
	size = "1rem",
	color = "white",
	className = "",
}) => {
	const resolvedColor = SPINNER_COLORS[color] || color;
	return (
	<svg
		className={`btn-spinner${className ? ` ${className}` : ""}`}
		style={{ width: size, height: size, display: "inline-block", verticalAlign: "middle", marginLeft: "6px" }}
		viewBox="0 0 50 50"
		xmlns="http://www.w3.org/2000/svg"
		role="status"
		aria-label="Loading">
		<circle
			className="loading-spinner__track"
			cx="25"
			cy="25"
			r="20"
			fill="none"
			strokeWidth={8}
			style={{ stroke: "rgba(255,255,255,0.3)" }}
		/>
		<circle
			className="loading-spinner__arc"
			cx="25"
			cy="25"
			r="20"
			fill="none"
			strokeWidth={8}
			strokeLinecap="round"
			style={{ stroke: resolvedColor }}
		/>
	</svg>
	);
};

export const LoadingDots = ({
	className = "",
	center = false,
	color,
}) => {
	const classes = [
		"loading-dots",
		center && "loading-dots--center",
		className,
	]
		.filter(Boolean)
		.join(" ");

	const dotStyle = color ? { backgroundColor: color } : undefined;

	return (
		<div className={classes}>
			<span style={dotStyle} />
			<span style={dotStyle} />
			<span style={dotStyle} />
		</div>
	);
};
